
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Modal from '../../../components/modal';
import Clickable from '../../../components/clickable/Clickable';
import PulpoField from '../../../pulpo_visualizer/fields';
import Button from '../../../components/button/button';
import styles from '../../Badging/Detail/detail.module.scss';
import Attachments from '../../forms/components/Attachments';

const SaveAlert = (props) => {
  const { alert, setAlert, handelSubmit, hasNoDraft } = props;
  return (
    <Modal
      showIn={alert} onClose={() => {}}
      minHeight="100px" width="554px" disableOutsideClick
    >
      <div style={{ padding: '20px 20px 10px' }}>
        <FormattedMessage
          id=" "
          tagName="h4"
          defaultMessage={`Some attachments could not be uploaded due to a network error.
            Please ${hasNoDraft ? 'refresh and' : 'save your progress to prevent data loss and'} try again.`}
        />
      </div>
      <div className={styles.submitButton}>
        {!hasNoDraft && (
          <Button
            action="primary"
            onClick={() => { handelSubmit(); setAlert(false); }}
            translationID="inspections.complete_inspections.save_as_draft"
            defaultText="Save as Draft"
          />
        )}
        <Button
          action="tertiary"
          onClick={() => setAlert(false)}
          translationID="close"
          defaultText="Close"
        />
      </div>
    </Modal>
  );
};

const RevokeApplication = (props) => {
  const {
    revokePopupOpen,
    handleCloseActionComp,
    handleActionsAnswerComp,
    revokeRemarks,
    revokeFieldError,
    handleActionSuspenRevoke,
    revokeAction,
    handleFieldErrorChanged,
    revokeAVPAction
  } = props;
  return (
    <div>
      <Modal
        showIn={revokePopupOpen}
        onClose={() => handleCloseActionComp()}
        width="500px"
        minHeight="150px"
        centered
      >
        <div className={styles.newTask}>
          <div
            className={styles.closeicon}
            style={{ padding: '15px 15px 0px 15px' }}
          >
            <FormattedMessage
              tagName="p"
              id="adp.log.revoke.application"
              defaultMessage="Revoke Application"
            />
            <Clickable onClick={() => handleCloseActionComp()}>
              <div style={{ cursor: 'pointer' }}>X</div>
            </Clickable>
          </div>
          <div className={styles.subHeading} style={{ fontWeight: '500' }}>
            <PulpoField
              key="revokeRemarks"
              id="revokeRemarks"
              type="string"
              isRequired
              translationID="asset_registry.table.front_display"
              title="Please provide reason for revoke"
              widget={{ type: 'textarea' }}
              handleValueChange={a => handleActionsAnswerComp(a)}
              answer={revokeRemarks}
              handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)}
              showFieldErrors={!revokeRemarks && revokeFieldError}
            />
          </div>
          <div
            className={styles.notefooter}
            style={{ justifyContent: 'flexEnd', gap: '3%' }}
          >
            <Button
              action="teritory"
              onClick={() => handleCloseActionComp()}
              translationID="todo.newTask.cancel"
              defaultText="Cancel"
            />
            <div className={styles.saveWrapper1}>
              <Button
                onClick={() => handleActionSuspenRevoke('revoke')}
                translationID="adp.application.revoke.title"
                defaultText="Revoke"
                action="danger"
                disabled={revokeAction?.loading || revokeAVPAction?.loading || false}
              />
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

const SuspendApplication = (props) => {
  const {
    suspenPopupOpen,
    handleCloseSuspendComp,
    handleFalseErrors,
    handleSuspendAnswer,
    suspendAction,
    suspend_type_select,
    suspendFieldError,
    suspend_untill_date,
    suspendRemarks,
    handleActionSuspenRevoke,
    handleFieldErrorChanged,
    suspendAVPAction
  } = props;
  return (
    <Modal
      showIn={suspenPopupOpen}
      onClose={() => handleCloseSuspendComp()}
      width="500px"
      minHeight="150px"
      centered
    >
      <div className={styles.newTask}>
        <div
          className={styles.closeicon}
          style={{ padding: '15px 15px 0px 15px' }}
        >
          <FormattedMessage
            tagName="p"
            id="adp.log.suspend.application"
            defaultMessage="Suspend Application"
          />
          <Clickable
            onClick={() => {
              handleCloseSuspendComp();
              handleFalseErrors();
            }}
          >
            <div style={{ cursor: 'pointer' }}>X</div>
          </Clickable>
        </div>
        <div className={styles.subHeading} style={{ fontWeight: '500' }}>
          <PulpoField
            key="suspend_type_select"
            id="suspend_type_select"
            type="select"
            title="Suspend"
            translationID="suspend.adp.application.title"
            handleValueChange={(e, a) => handleSuspendAnswer(e, a)}
            answer={suspend_type_select}
            isRequired
            showFieldErrors={suspendFieldError}
            handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)}
            values={[
              { key: 'manual', value: 'Untill further notice' },
              { key: 'date', value: 'Untill specified date' }
            ]}
          />
          {suspend_type_select === 'date' && (
            <PulpoField
              key="suspend_untill_date"
              id="suspend_untill_date"
              type="date"
              title="Date"
              translationID="suspend.adp.application.title"
              handleValueChange={(e, a) => handleSuspendAnswer(e, a)}
              answer={suspend_untill_date}
              isRequired
              showFieldErrors={suspendFieldError}
              handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)}
              noDefault
            />
          )}
          <PulpoField
            key="suspendRemarks"
            id="suspendRemarks"
            type="string"
            isRequired
            translationID="asset_registry.table.front_display"
            handleValueChange={(e, a) => handleSuspendAnswer(e, a)}
            title="Please provide reason for suspension"
            widget={{ type: 'textarea' }}
            handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)}
            answer={suspendRemarks}
            showFieldErrors={suspendFieldError}
          />
        </div>
        <div
          className={styles.notefooter}
          style={{ justifyContent: 'flexEnd', gap: '3%' }}
        >
          <Button
            action="teritory"
            onClick={() => {
              handleCloseSuspendComp();
              handleFalseErrors();
            }}
            translationID="todo.newTask.cancel"
            defaultText="Cancel"
          />
          <div className={styles.saveWrapper1}>
            <Button
              onClick={() => handleActionSuspenRevoke('suspend')}
              translationID="adp.application.suspend.title"
              defaultText="Suspend"
              action="danger"
              disabled={suspendAction?.loading || suspendAVPAction?.loading || false}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

const UpdateRequiredDocuments = (props) => {
  const { reqAttachmentFields, updateDocuments, handleUpdateDocuments, customFields, logData, documentList } = props;

  const obj_att = logData?.attachments?.reduce((acc, obj) => ({ ...acc, [obj.attachment_id]: obj }), {});
  const reqAttachments = logData?.req_attachments && Object.keys(logData.req_attachments)
    .reduce((acc, key) => ({ ...acc, [key]: logData.req_attachments[key].map(att => obj_att[att]) }), {});
  const normalizedDocumentList = Array.isArray(documentList)
    ? documentList.reduce((acc, value) => acc.concat(value), [])
    : `${documentList || ''}`.split(',');
  const rejectedDocumentIds = new Set(normalizedDocumentList.filter(Boolean).map(id => `${id}`));
  const isRejectedDocument = attachment => rejectedDocumentIds.has(`${attachment?.attachment_id || attachment?.id || attachment}`);
  let defaultAttach = {
    id: 'attachments',
    required: true,
    title: 'Attachments',
    type: 'attachments'
  };
  let profile = [
    {
      id: 'photo',
      required: true,
      title: 'Profile Picture',
      type: 'attachments',
      singleAttachment: true
    }
  ];
  return (
  <div className={styles.newTask}>
    <div style={{ padding: '15px 30px 0px 30px', minHeight: '370px' }} className={styles.bodies}>
    {Object.keys(reqAttachmentFields || {})?.length !== 0 && (
      <>
        {reqAttachmentFields.map((ele, i) => {
          const attachmentKey = `${typeof ele === 'object' ? ele.attachmentName : ele}_attachments`;
          const filteredAttachments = (reqAttachments?.[attachmentKey] || []).filter(isRejectedDocument);

          if (filteredAttachments.length === 0) return null; // Skip rendering if no rejected attachments

          const fieldErrors = updateDocuments?.document_errors?.[attachmentKey] || false;
          const storedAttachments = updateDocuments?.req_attachments?.[attachmentKey] || [];
          const dateAnswer = updateDocuments?.req_attachments_details?.req_attachments_dates?.[`${ele.attachmentName}_date`];

          return (
            <div key={attachmentKey}>
              <p>{`(${i + 1}) ${ele.attachmentName}`}</p>
              <Attachments
                {...defaultAttach}
                handleAnswerChanged={a => handleUpdateDocuments('req_attachments', a, attachmentKey)}
                attachments={storedAttachments}
                showFieldErrors={fieldErrors}
                handleRemoveCustomAttachment={attchId => handleUpdateDocuments('removed_attachements', attchId)}
                handleFieldErrorChanged={() => ({})}
              />
              {ele.showDateField && (
                <PulpoField
                  key="date"
                  id="date"
                  type="date"
                  translationID="puplpofield.expiry.date"
                  title="Expiry Date"
                  className={`${styles.marginBottom} ${styles.dateWidth}`}
                  isRequired
                  handleValueChange={(a, b) => handleUpdateDocuments('req_attachments_dates', a, `${ele.attachmentName}_${b}`)}
                  answer={dateAnswer}
                  handleFieldErrorChanged={() => ({})}
                />
              )}
            </div>
          );
        })}
      </>
    )}
    {logData?.photo?.length > 0 && (
      profile.map((ele) => {
        const attachments = logData?.photo || []; // Get attachments, ensure it's an array
        const rejectedAttachments = attachments.filter(isRejectedDocument);
        return rejectedAttachments.length > 0 ? (
          <Attachments
            {...ele}
            handleAnswerChanged={a => handleUpdateDocuments('photo', a)}
            attachments={updateDocuments?.[ele.id] || []}
            showFieldErrors={updateDocuments?.showDocumentError || false}
            handleRemoveCustomAttachment={attchId => handleUpdateDocuments('removed_attachements', attchId)}
            handleFieldErrorChanged={() => ({})}
          />
        ) : null;
      })
    )}
    {customFields?.map((ele) => {
      const attachments = logData?.response?.[ele.id] || []; // Get attachments, ensure it's an array
      const rejectedAttachments = attachments.filter(isRejectedDocument);
      return rejectedAttachments.length > 0 ? (
        <Attachments
          {...ele}
          handleAnswerChanged={(a, b) => handleUpdateDocuments('response', a, b)}
          attachments={updateDocuments?.response?.[ele.id] || []}
          showFieldErrors={updateDocuments?.showDocumentError || false}
          handleRemoveCustomAttachment={attchId => handleUpdateDocuments('removed_attachements', attchId)}
          handleFieldErrorChanged={() => ({})}
        />
      ) : null;
    })}
    </div>
  </div>
  );
};

const UploadAvpDocuments = (props) => {
  const { handleUploadDocuments, customFields, uploadDocuments } = props;

  let attachment = {
    conditional: false,
    default: false,
    description: '',
    enable_ocr: false,
    full_width: false,
    id: 'attachments',
    internal: true,
    list_view: false,
    lock: false,
    required: true,
    search_enable: false,
    source_fields: [],
    system_generated: false,
    title: 'Attachments',
    type: 'attachments'
  };
  return (
    <div className={styles.newTask}>
      <div className={styles.modalStyle}>
        <Attachments
          {...attachment}
          handleAnswerChanged={a => handleUploadDocuments('attachments', a)}
          attachments={uploadDocuments?.[attachment.id]}
          showFieldErrors={uploadDocuments.showDocumentError || false}
          handleRemoveCustomAttachment={a => handleUploadDocuments('removed_attachments', a)}
          handleFieldErrorChanged={() => ({})}
        />
        {customFields.map(ele => (
          <Attachments
            {...ele}
            handleAnswerChanged={(a, b) => handleUploadDocuments('response', a, b)}
            attachments={uploadDocuments?.response?.[ele.id] || []}
            showFieldErrors={uploadDocuments.showDocumentError || false}
            handleRemoveCustomAttachment={attchId => handleUploadDocuments('removed_attachements', attchId)}
            handleFieldErrorChanged={() => ({})}
          />
        ))}
      </div>
    </div>
  );
};

export const calculateTotalValue = ({
  feeCategoryData,
  taxData,
  applicationType,
  applicationFor,
  selectedCategory,
  isVatApplicable = false,
  roundTo = 2
}) => {
  const toNumber = v => (Number.isFinite(Number(v)) ? Number(v) : 0);

  function findTaxRateByVatCode(vatCode) {
    if (!vatCode) return 0;
    const row = taxData.find(
      t => String(t.tax_code || '').trim().toUpperCase() === String(vatCode).trim().toUpperCase()
    );
    return row ? toNumber(row.rate) : 0;
  }

  function isTenantFeeEnabled(tenant, application_Type) {
    if (!tenant || Object.keys(tenant).length === 0) return true;
    const type = application_Type.toLowerCase();
    return type === 'renewal'
      ? tenant.renewalFee ?? tenant.renewal ?? true
      : tenant.newFee ?? tenant.new ?? true;
  }

  const filtered = (feeCategoryData || []).filter(
    item => item.category?.name === selectedCategory && item.name === applicationFor
  );

  const grandTotal = filtered.reduce((total, item) => {
    if (!isTenantFeeEnabled(item.tenant_fee_details, applicationType)) {
      return total;
    }

    const feeKey = applicationType.toLowerCase() === 'renewal' ? 'renewalFee' : 'newFee';
    const baseFee = toNumber(item?.fee_details?.[feeKey]);
    const taxRate = findTaxRateByVatCode(item?.fee_details?.vatCode);
    const taxAmount = isVatApplicable ? baseFee * (taxRate / 100) : 0;

    return total + baseFee + taxAmount;
  }, 0);

  return Number(grandTotal.toFixed(roundTo));
};

export const getFeeWithInvoice = ({
  description,
  feeCategoryData,
  taxData = [],
  applicationType,
  applicationFor,
  selectedCategory = '',
  isVatApplicable = false,
  roundTo = 2,
  feeCategory = null // optional details { id, name }
}) => {
  const toNumber = v => (Number.isFinite(Number(v)) ? Number(v) : 0);

  const findTaxRateByVatCode = (vatCode) => {
    if (!vatCode) return 0;
    const row = taxData?.find(
      t => String(t.tax_code || '').trim().toUpperCase()
        === String(vatCode).trim().toUpperCase()
    );
    return row ? toNumber(row.rate) : 0;
  };

  const isTenantFeeEnabled = (tenant = {}, application_type = '') => {
    if (!tenant || Object.keys(tenant).length === 0) return true;
    const type = application_type.toLowerCase();
    return type === 'renewal'
      ? tenant.renewalFee ?? tenant.renewal ?? true
      : tenant.newFee ?? tenant.new ?? true;
  };

  const feeKey = applicationType?.toLowerCase() === 'renewal' ? 'renewalFee' : 'newFee';
  const round = v => Number(v.toFixed(roundTo));

  // Step 1: Filter by selectedCategory and applicationFor
  let invoiceObject = (feeCategoryData || []).filter(
    item => item.category?.name?.toLowerCase() === selectedCategory?.toLowerCase()
      && item.name === applicationFor
  );

  // Step 2: If feeCategory is provided, filter by id
  if (feeCategory && feeCategory.id) {
    invoiceObject = invoiceObject.filter(
      item => item.fee_category?.id === feeCategory.id || item.id === feeCategory.id
    );
  }

  // Step 3: Map to invoice with fees and tax
  invoiceObject = invoiceObject
    .map((item) => {
      if (!isTenantFeeEnabled(item.tenant_fee_details, applicationType)) return null;

      const baseFee = toNumber(item?.fee_details?.[feeKey]);
      const vatCode = item?.fee_details?.vatCode;
      const taxRate = findTaxRateByVatCode(vatCode);
      const taxAmount = isVatApplicable ? baseFee * (taxRate / 100) : 0;
      const lineTotal = baseFee + taxAmount;

      return {
        id: item.id,
        category: item.category?.name ?? null,
        feeCategoryName: item.fee_category?.name || item.fee_name || null,
        applicationFor: item.name ?? null,
        applicationType: applicationType ?? null,
        baseFeeWithoutTax: round(baseFee),
        vatCode: vatCode ?? null,
        taxRate: round(taxRate),
        taxAmount: round(taxAmount),
        totalFeeWithTax: round(lineTotal)
      };
    })
    .filter(Boolean); // remove nulls (disabled tenant fees)

  // Step 4: Reduce totals
  const [grandTotal, subTotalWithoutTax, vatAmount] = invoiceObject.reduce(
    ([g, s, v], l) => [
      g + l.totalFeeWithTax,
      s + l.baseFeeWithoutTax,
      v + l.taxAmount
    ],
    [0, 0, 0]
  ).map(round);

  return {
    description,
    fee_type: applicationFor,
    count: invoiceObject.length,
    invoiceObject,
    grandTotal: grandTotal || 0,
    subTotalWithoutTax,
    vatAmount
  };
};


export { RevokeApplication, SuspendApplication, UpdateRequiredDocuments, UploadAvpDocuments, SaveAlert };
